import * as z from "zod";

export const Category = z
  .object({
    categoryId: z.string().nullable(),
    name: z.string().nullable(),
    color: z.string().nullable(),
  })
  .partial({ categoryId: true });
